import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React from 'react';

export const TwitterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.88 4.141a3.608 3.608 0 001.622-1.984 7.523 7.523 0 01-2.345.87 3.732 3.732 0 00-2.695-1.132c-2.04 0-3.692 1.606-3.692 3.587 0 .28.03.555.094.817A10.588 10.588 0 011.253 2.55a3.5 3.5 0 00-.5 1.804c0 1.244.652 2.342 1.643 2.986a3.79 3.79 0 01-1.673-.448v.044c0 1.739 1.272 3.189 2.963 3.517-.31.084-.636.127-.974.127-.238 0-.47-.022-.694-.064.47 1.424 1.833 2.463 3.45 2.49A7.549 7.549 0 01.88 14.544c-.298 0-.593-.015-.881-.05a10.683 10.683 0 005.66 1.612c6.794 0 10.507-5.466 10.507-10.207 0-.156-.002-.31-.01-.463A7.364 7.364 0 0018 3.577a7.543 7.543 0 01-2.12.564z"
        clipRule="evenodd"
      />
    </SvgIcon>
  );
};
